import config from 'login/config/environment';

export default class Version {
  version = config.APP.version;
  shortVersion = config.APP.shortVersion;
}
